// Fonte única das etapas de onboarding do parceiro.
// Consumido por: DialogOnboarding (wizard + tutorial), OnboardingFab (banner de
// confirmação), AppDrawer (bloqueio do menu) e o guard do router.

const CDN_ONBOARDING = 'https://labcinco.nyc3.cdn.digitaloceanspaces.com/bigou/pedidos';
const tutorialGif = (nome) => `${CDN_ONBOARDING}/${nome}.gif`;

export const WHATSAPP_SUPORTE = '5532988929726';

// Itens do menu que continuam liberados durante o onboarding: o contrato é uma
// pendência jurídica que o parceiro precisa resolver em qualquer etapa.
export const SELETORES_LIBERADOS = ['contrato'];

export const ETAPAS_ONBOARDING = [
  {
    campo: 'etapa_cardapio',
    titulo: 'Cardápio',
    descricao: 'Verifique se todos os itens do seu cardápio estão corretos e com preços atualizados.',
    icone: 'restaurant_menu',
    cor: 'primary',
    rota: '/delivery/cardapio',
    seletor: 'cardapio',
    textoBotao: 'Ir para o Cardápio',
    videoUrl: tutorialGif('etapa_cardapio'),
    pontos: [
      'Verifique os nomes e descrições de cada item',
      'Confirme os preços e corrija qualquer valor desatualizado',
      'Ative somente os itens disponíveis para venda agora',
      'Organize os itens em categorias para facilitar a busca do cliente',
      'Configure variações (tamanho, sabor, etc.) se houver',
    ],
    banner: {
      titulo: 'Cardápio conferido?',
      descricao: 'Verifique se todos os itens estão corretos e com preços atualizados.',
    },
  },
  {
    campo: 'etapa_horario',
    titulo: 'Horário de Funcionamento',
    descricao: 'Configure os dias e horários em que sua loja estará disponível para pedidos.',
    icone: 'schedule',
    cor: 'deep-purple',
    rota: '/delivery/horario',
    seletor: 'horario',
    textoBotao: 'Ir para Horários',
    videoUrl: tutorialGif('etapa_horario'),
    pontos: [
      'Defina os dias da semana em que sua loja funciona',
      'Configure início e fim de cada turno',
      'Você pode ter até 2 turnos por dia (ex: almoço e jantar)',
      'Use "Copiar" para replicar o horário do dia anterior',
      'Salve clicando no botão verde ao finalizar',
    ],
    banner: {
      titulo: 'Horários conferidos?',
      descricao: 'Confirme os dias e horários de funcionamento da sua loja.',
    },
  },
  {
    campo: 'etapa_pagamento',
    titulo: 'Formas de Pagamento',
    descricao: 'Defina quais formas de pagamento você aceita: dinheiro, cartão, vale...',
    icone: 'payment',
    cor: 'teal',
    rota: '/delivery/pagamento',
    seletor: 'pagamento',
    textoBotao: 'Ir para Pagamento',
    videoUrl: tutorialGif('etapa_pagamento'),
    pontos: [
      'Marque todas as formas que sua loja aceita',
      'Inclua dinheiro, cartão de crédito e débito se aceitar',
      'Habilite Pix se aceitar pagamento por QR Code',
      'Para cartão, selecione as bandeiras aceitas (Visa, Mastercard, etc.)',
    ],
    banner: {
      titulo: 'Pagamentos conferidos?',
      descricao: 'Verifique as formas de pagamento que você aceita.',
    },
  },
  {
    campo: 'etapa_entrega',
    titulo: 'Taxas de Entrega',
    descricao: 'Configure os bairros que você atende e as taxas de entrega para cada região.',
    icone: 'local_shipping',
    cor: 'indigo',
    rota: '/delivery/entrega',
    seletor: 'entrega',
    textoBotao: 'Ir para Entrega',
    videoUrl: tutorialGif('etapa_entrega'),
    pontos: [
      'Adicione todos os bairros em que sua loja faz entregas',
      'Defina uma taxa para cada bairro (pode ser R$ 0,00 se for grátis)',
      'Bairros mais distantes costumam ter taxas maiores',
      'Revise se os bairros batem com sua área real de atendimento',
    ],
    banner: {
      titulo: 'Entrega conferida?',
      descricao: 'Confira os bairros atendidos e as taxas de entrega.',
    },
  },
  {
    campo: 'etapa_configuracoes',
    titulo: 'Configurações',
    descricao: 'Defina o tempo estimado de entrega e retirada para seus clientes.',
    icone: 'tune',
    cor: 'blue-grey',
    rota: '/delivery/configuracoes',
    seletor: 'configuracoes',
    textoBotao: 'Ir para Configurações',
    videoUrl: tutorialGif('etapa_configuracoes'),
    pontos: [
      'Ajuste o tempo médio de entrega (delivery) em minutos',
      'Ajuste o tempo médio de retirada no balcão',
      'Considere tempo de preparo + deslocamento do entregador',
      'Em horários de pico o tempo real é maior e deixe uma margem',
    ],
    banner: {
      titulo: 'Configurações conferidas?',
      descricao: 'Confira o tempo de entrega e retirada para seus clientes.',
    },
  },
];

// Compara dois caminhos ignorando barra(s) final(is): a rota do cardápio é
// registrada como '/delivery/cardapio/' e normalizada para '/delivery/cardapio'.
export function mesmaRota (a, b) {
  const limpar = (p) => (p || '').replace(/\/+$/, '');
  return limpar(a) === limpar(b);
}

export function getEtapa (campo) {
  return ETAPAS_ONBOARDING.find(e => e.campo === campo) || null;
}

export function etapaConcluida (onboardingData, campo) {
  return !!(onboardingData && onboardingData[campo] == 1);
}

// Etapa "da vez": a primeira ainda não concluída.
export function etapaAtualDe (onboardingData) {
  if (!onboardingData) return null;
  return ETAPAS_ONBOARDING.find(e => !etapaConcluida(onboardingData, e.campo)) || null;
}

// Monta a lista de etapas com o estado de conclusão de cada uma.
export function etapasComStatus (onboardingData) {
  if (!onboardingData) return [];
  return ETAPAS_ONBOARDING.map(e => ({ ...e, concluida: etapaConcluida(onboardingData, e.campo) }));
}

export function contatoOnboarding (onboardingData, fallback) {
  const contato = (onboardingData && onboardingData.contato_responsavel) || null;
  const telefone = String((contato && contato.telefone) || fallback || WHATSAPP_SUPORTE).replace(/\D/g, '');
  return {
    telefone: telefone || WHATSAPP_SUPORTE,
    nome: (contato && contato.nome) || '',
    origem: (contato && contato.origem) || 'suporte',
  };
}

// Origem sinalizada na query ao mandar o parceiro do onboarding para a tela de
// Marketing: com as etapas concluídas ele é convidado a ativar promoções e
// cupons, e a tela usa esse marcador para rolar direto até as ações.
export const ORIGEM_ONBOARDING = 'onboarding';
